import React from 'react';
import { Result, Button, Space, Typography } from 'antd';
import { 
  ReloadOutlined, 
  DisconnectOutlined,
  WarningOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';
import { motion } from 'framer-motion';
import './NetworkErrorDisplay.css';

const { Text, Title } = Typography;

const NetworkErrorDisplay = ({ error, onRetry, message }) => {
  // Determinar el tipo de error
  const isTimeout = error?.code === 'ECONNABORTED' || 
                    error?.message?.includes('timeout');
  
  const isNetworkError = error?.message?.includes('Network Error') || 
                         !navigator.onLine;
  
  const getErrorIcon = () => {
    if (isTimeout) return <ClockCircleOutlined />;
    if (isNetworkError) return <DisconnectOutlined />;
    return <WarningOutlined />;
  };
  
  const getErrorTitle = () => {
    if (isTimeout) return "Tiempo de espera agotado";
    if (isNetworkError) return "Error de conexión";
    return "Algo salió mal";
  };
  
  const getErrorMessage = () => {
    if (message) return message;
    
    if (isTimeout) {
      return "La solicitud ha tardado demasiado tiempo. Puede que el servidor esté ocupado o tu conexión sea lenta.";
    }
    
    if (isNetworkError) {
      return "No se pudo conectar al servidor. Por favor, verifica tu conexión a Internet.";
    }
    
    return "Ha ocurrido un error al cargar los datos. Por favor, intenta nuevamente.";
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="network-error-container"
    >
      <Result
        status="warning"
        title={getErrorTitle()}
        subTitle={getErrorMessage()}
        icon={
          <div className="custom-error-icon">
            {getErrorIcon()}
          </div>
        }
        extra={
          <Space direction="vertical" align="center">
            <Button 
              type="primary" 
              icon={<ReloadOutlined />} 
              onClick={onRetry}
              className="retry-button"
            >
              Reintentar
            </Button>
            <Text type="secondary">
              Si el problema persiste, intente más tarde o contacte al soporte.
            </Text>
          </Space>
        }
      />
    </motion.div>
  );
};

export default NetworkErrorDisplay;
